<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addTravel">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="travelList" class="button-box">
      <el-table-column label="旅行标题" prop="title"></el-table-column>
      <el-table-column label="地址" prop="addr.addr"></el-table-column>
      <el-table-column label="球场" prop="courtName"></el-table-column>
      <el-table-column label="排序" prop="resort"></el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="viewTravel(scope.row)">查看</el-button></div>
              <div><el-button icon="el-icon-edit" @click="editTravel(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeTravelById(scope.row.id)">删除</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getTravelList" /></div>

  </div>
</template>
<script>
import { getPostOrDeleteData } from '@/utils/code'
import { deleteTravel, getTravelList } from '@/api/travel/travel'
import Pagination from '@/components/common/Pagination/index'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, Pagination },
  data() {
    return {
      queryInfo: {keyword: ''},
      travelList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    //查询列表
    getTravelList(page, cb) {
      getTravelList({"enumSort": "SETT","sort": "ASC",...page}).then((response) => {
        this.travelList = cb(response)
      })
    },

    //根据ID删除数据
    removeTravelById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTravel(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getTravelList()
          }
        })
      }).catch(() => {
      })
    },

    viewTravel(row) {
      this.$router.push({
        path: '/viewTravel',
        query: {
          id: row.id
        }
      })
    },

    //新增
    addTravel() {
      this.$router.push('/addTravel')
    },

    //修改
    editTravel(row) {
      this.$router.push({ path: '/editTravel', query: { id: row.id } })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    }

  }
}
</script>

<style lang="less" scoped>

</style>
